module.exports = {
  entry: './src/apps/cyber-resilience-assessment/index.tsx',
  shortcode: 'cyber-resilience-assessment',
  title: 'Cyber Resilience Assessment',
  status: 'stable',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-cyber-resilience-assessment-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/'],
    availableTranslations: ['en'],
    org: 'digitalsales', // to filter the widget
    brand: 'infrastructure', // automation, dataai, security, sustainabilty, storage, other
    widgetLocation: '/flashsystem', // default '/pricing' but sometimes '/'
    productName: '', // the product name in the URL
    description: 'Allows users to determine a savings.',
    activatedCountryPages: ['us-en'],
  },
};
